/**
 * Activate a specific ad unit e.g. `sb_left`
 * @param {string} adUnit
 */
export function activateAdUnit(adUnit) {
  if (typeof window.adngin?.cmd?.startAuction === 'function') {
    window.adngin.cmd.startAuction([adUnit]);
  } else {
    window.snigelPubConf.adengine.activeAdUnits.push(adUnit);
  }
}

export function loadAdScript(onLoad) {
  window.googletag = window.googletag || { cmd: [] };
  window.snigelPubConf = {
    adengine: {
      activeAdUnits: [''],
    },
  };

  const href = window.location.href;
  let src = '';
  if (href.includes('staging') || href.includes('localhost') || href.includes('pages.dev')) {
    console.log('Loading STAGING ads script');
    src = 'https://staging-cdn.snigelweb.com/adengine/geogridgame.com/loader.js';
    // eslint-disable-next-line no-undef
    window.googletag.cmd.push(function () {
      // eslint-disable-next-line no-undef
      googletag.pubads().set('page_url', 'geogridgame.com');
    });
  } else {
    console.log('Loading LIVE ads script');
    src = 'https://cdn.snigelweb.com/adengine/geogridgame.com/loader.js';
  }

  const node = document.createElement('script');
  node.onload = onLoad;
  node.src = src;
  node.type = 'text/javascript';
  node.async = true;
  node.setAttribute('data-cfasync', 'false');
  if (!document.querySelector('script[src*="adengine/geogridgame.com/loader.js')) {
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}

/**
 * Check for consent through Snigel, then set GA consent
 */
export const checkForConsent = () => {
  window.addEventListener('adnginLoaderReady', function () {
    window.adconsent &&
      window.adconsent('getConsent', null, function (consent, success) {
        if (success) {
          if (consent.fullConsent) {
            console.log('########### yas consent');
            window.gtag('consent', 'update', {
              ad_storage: 'granted',
              analytics_storage: 'granted',
              ad_user_data: 'granted',
              ad_personalization: 'granted',
            });
          } else {
            console.log('########### naur consent');
            clearAnalyticsCookies();
          }
        }
      });
  });
};

function clearAnalyticsCookies() {
  const teuteufCookieNames = [
    '_gid',
    '_ttp',
    '_tt_enable_cookie',
    'ttcsid',
    'ttcsid_D0CGS9RC77UFFMMCQ0R0',
  ];
  const tiktokCookieNames = ['_ttp'];

  // delete all _ga cookies
  document.cookie
    .split(';')
    .map((c) => c.trim())
    .forEach((cookie) => {
      const name = cookie.split('=')[0];
      if (name.startsWith('_ga')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.geogridgame.com`;
      }
    });

  // delete other analytics cookies
  teuteufCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.geogridgame.com`;
  });
  tiktokCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tiktok.com;`;
  });
}
